import React, { useState } from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	useMediaQuery,
	Slide,
	Grid,
	useTheme,
	makeStyles,
	IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { validarRUT } from "validar-rut";
import { useForm } from "react-hook-form";
import MaskedInput from "react-text-mask";
import { TextField } from "./";

export default function EditOperator(props) {
	const theme = useTheme();
	const classes = useStyles();
	const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
	const { register, handleSubmit, errors } = useForm();
	const { editOperator, operator, close } = props;
	const [rut, setRut] = useState(operator.rut);

	const updateOperator = async (dataToEdit) => {
		const updatedOperator = {
			username: dataToEdit.username,
			email: dataToEdit.email,
			operator: {
				name: dataToEdit.name,
				rut: dataToEdit.rut,
				address: dataToEdit.address,
				contact: dataToEdit.contact,
				phone: dataToEdit.phone,
			},
		};
		close();
		editOperator(props.operator.user._id, updatedOperator);
	};

	return (
		<Dialog
			PaperProps={{ style: { borderRadius: 45 } }}
			maxWidth="sm"
			fullScreen={fullScreen}
			open={props.open}
			TransitionComponent={Transition}
		>
			<IconButton aria-label="close" className={classes.closeButton} onClick={props.close}>
				<CloseIcon />
			</IconButton>
			<DialogTitle className={classes.dialogTitle}>Editar Operador</DialogTitle>
			<DialogContent>
				<form className={classes.form} onSubmit={handleSubmit(updateOperator)}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6}>
							<TextField
								variant="outlined"
								fullWidth
								id="name"
								placeholder="Nombre *"
								name="name"
								autoComplete="name"
								defaultValue={operator.name}
								size="small"
								inputRef={register({
									required: "Nombre requerido",
								})}
								InputLabelProps={{
									shrink: true,
								}}
								error={errors.name ? true : false}
								helperText={errors.name ? errors.name.message : ""}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								variant="outlined"
								fullWidth
								id="rut"
								placeholder="Rut *"
								name="rut"
								autoComplete="rut"
								value={rut}
								onChange={(e) => setRut(e.target.value)}
								size="small"
								inputComponent={TextMaskCustom}
								inputRef={register({
									required: "Rut requerido",
									validate: (value) => validarRUT(value) || "Rut incorrecto",
								})}
								InputLabelProps={{
									shrink: true,
								}}
								error={errors.rut ? true : false}
								helperText={errors.rut ? errors.rut.message : ""}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								variant="outlined"
								fullWidth
								id="email"
								placeholder="Correo electrónico *"
								name="email"
								size="small"
								autoComplete="email"
								defaultValue={operator.user.email}
								inputRef={register({
									required: "Correo requerido",
									pattern: {
										value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
										message: "Formato de correo inválido",
									},
								})}
								InputLabelProps={{
									shrink: true,
								}}
								error={errors.email ? true : false}
								helperText={errors.email ? errors.email.message : ""}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								variant="outlined"
								fullWidth
								id="address"
								placeholder="Dirección *"
								name="address"
								autoComplete="address"
								defaultValue={operator.address}
								size="small"
								inputRef={register({
									required: "Dirección requerida",
								})}
								InputLabelProps={{
									shrink: true,
								}}
								error={errors.address ? true : false}
								helperText={errors.address ? errors.address.message : ""}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								variant="outlined"
								fullWidth
								id="contact"
								placeholder="Contacto *"
								name="contact"
								autoComplete="cotact"
								size="small"
								defaultValue={operator.contact}
								inputRef={register({
									required: "Persona de contacto requerida",
								})}
								InputLabelProps={{
									shrink: true,
								}}
								error={errors.contact ? true : false}
								helperText={errors.contact ? errors.contact.message : ""}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								variant="outlined"
								fullWidth
								id="phone"
								placeholder="Teléfono *"
								name="phone"
								autoComplete="phone"
								defaultValue={operator.phone}
								size="small"
								inputRef={register({
									required: "Teléfono requerida",
								})}
								InputLabelProps={{
									shrink: true,
								}}
								error={errors.phone ? true : false}
								helperText={errors.phone ? errors.phone.message : ""}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								variant="outlined"
								fullWidth
								id="username"
								placeholder="Usuario *"
								name="username"
								type="username"
								autoComplete="username"
								defaultValue={operator.user.username}
								size="small"
								inputRef={register({
									required: "Usuario requerido",
								})}
								InputLabelProps={{
									shrink: true,
								}}
								error={errors.username ? true : false}
								helperText={errors.username ? errors.username.message : ""}
							/>
						</Grid>
					</Grid>
					<DialogActions>
						<Button
							type="submit"
							fullWidth
							size="small"
							variant="contained"
							color="secondary"
							className={classes.submit}
							style={{ textTransform: "capitalize", borderRadius: "20px" }}
						>
							Guardar
						</Button>
					</DialogActions>
				</form>
			</DialogContent>
		</Dialog>
	);
}

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

function TextMaskCustom(props) {
	const { inputRef, ...other } = props;
	const { value } = other;

	return (
		<MaskedInput
			{...other}
			ref={(ref) => {
				inputRef(ref ? ref.inputElement : null);
			}}
			mask={
				value.length <= 9
					? [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /[kK0-9]/, /[kK0-9]/]
					: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /[kK0-9]+/g]
			}
			placeholderChar={"\u2000"}
			placeholder="Rut *"
			guide={false}
			showMask
		/>
	);
}

const useStyles = makeStyles((theme) => ({
	form: {
		marginTop: theme.spacing(2),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
	textField: {
		width: "100%",
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(2),
		top: theme.spacing(2),
		color: "#FFF",
		backgroundColor: theme.palette.secondary.main,
		width: 30,
		height: 30,
		"&:hover": {
			backgroundColor: theme.palette.secondary.main,
		},
	},
	dialogTitle: {
		textAlign: "left",
		color: theme.palette.primary.main,
		"& h2": {
			fontWeight: "bold",
		},
	},
}));
